module.exports = __webpack_public_path__ + "img/45.235d46a8.jpg";